'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024 from "./presto.types$-User-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_Proxies$$anon$3(outer) {
  this.bqD = null;
  this.bqB = null;
  this.bqC = false;
  this.bqz = null;
  this.bqA = false;
  this.bqE = false;
  this.bqF = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bqD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Proxies$$anon$3 as $c_Lpresto_Proxies$$anon$3 };
$p = $c_Lpresto_Proxies$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Proxies$$anon$3;
/** @constructor */
function $h_Lpresto_Proxies$$anon$3() {
}
export { $h_Lpresto_Proxies$$anon$3 as $h_Lpresto_Proxies$$anon$3 };
$h_Lpresto_Proxies$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bqD;
});
$p.t = (function() {
  if ((!this.bqC)) {
    this.bqB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bqC = true;
  }
  return this.bqB;
});
$p.ae = (function() {
  if ((!this.bqA)) {
    this.bqz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dId$0024.$m_Lpresto_types$UserId$().adA(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bqA = true;
  }
  return this.bqz;
});
$p.w = (function() {
  if ((!this.bqF)) {
    this.bqE = false;
    this.bqF = true;
  }
  return this.bqE;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Proxies$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Proxies$$anon$3, "presto.Proxies$$anon$3", ({
  Pc: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Proxies$$anon$3 as $d_Lpresto_Proxies$$anon$3 };
//# sourceMappingURL=presto.-Proxies$$anon$3.js.map
